<template>
  <div class="app">
    <!-- <Agreement v-if="showAgreement" @agreement-accepted="handleAgreementAccepted" />
    <Welcome v-else-if="showWelcome" @transition-complete="handleTransitionComplete" ref="welcomeRef" />
    <Chat v-else :initial-state="chatInitialState" :history-messages="historyMessages" /> -->
    <Welcome v-if="showWelcome" @transition-complete="handleTransitionComplete" ref="welcomeRef" />
    <Chat v-else :initial-state="chatInitialState" :history-messages="historyMessages" />
    <!-- 进如/test页面
     <router-view /> -->
  </div>
</template>

<script>
import { ref } from 'vue'
import Welcome from './views/Welcome.vue'
import Chat from './views/Chat.vue'
//import Agreement from './views/Agreement.vue'
export default {
  name: 'App',
  components: {
    Welcome,
    Chat,
//    Agreement
  },
  setup() {
    //const showAgreement = ref(true) //控制agreement页面显示
   // const showWelcome = ref(false)//控制welcome页面显示
   const showWelcome = ref(true)
    const chatInitialState = ref('intro')//控制chat页面显示
    const historyMessages = ref([])
    const welcomeRef = ref(null)


    // 协议确认完成
    // const handleAgreementAccepted = () => {
    //   showAgreement.value = false
    //   showWelcome.value = true
    // }
    const handleTransitionComplete = (state = 'intro') => {
      
      console.log('=== App.vue 状态调试 ===')
    console.log('App.vue 接收到状态:', state)
    console.log('typeof state:', typeof state)
    console.log('state === "chatting":', state === 'chatting')
    console.log('========================')
      
      // 在进入 Intro 或 Chatting 之前，检查协议状态
      // 如果 agreement_consent 不是 '0'（同意），都需要阻止
      const agreementConsent = localStorage.getItem('agreement_consent')
      if (!agreementConsent || agreementConsent !== '0') {
        console.log('用户未同意协议或协议状态异常，阻止进入 Intro/Chatting 页面')
        // 保持 Welcome 页面显示，不切换状态
        return
      }
      
      chatInitialState.value = state
      
      // 如果有历史消息，从Welcome组件获取
      if (state === 'chatting' && welcomeRef.value) {
        historyMessages.value = welcomeRef.value.getHistoryMessages()
        console.log('App.vue 获取到历史消息:', historyMessages.value)
      }
      
      showWelcome.value = false
    }

    return {
     // showAgreement,
      showWelcome,
      chatInitialState,
      historyMessages,
      welcomeRef,
     // handleAgreementAccepted,
      handleTransitionComplete
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  height: 100vh;
  overflow: hidden;
  background: #fefefe;
  position: relative;
  margin: 0;
  padding: 0;
}

.app {
  width: 100%;
  height: 100vh;
}
</style>
